export const recentProjects = [
  {
    id: 1,
    link: "",
    isActive: "active",
    imgSrc: "images/home-project-1.jpg",
  },
  {
    id: 2,
    link: "",
    isActive: "",
    imgSrc: "images/home-project-2.jpg",
  },
  {
    id: 3,
    link: "",
    isActive: "",
    imgSrc: "images/home-project-3.jpg",
  },
  {
    id: 4,
    link: "",
    isActive: "",
    imgSrc: "images/home-project-4.jpg",
  },
  {
    id: 5,
    link: "",
    isActive: "",
    imgSrc: "images/home-project-5.jpg",
  },
  {
    id: 6,
    link: "",
    isActive: "",
    imgSrc: "images/home-project-6.jpg",
  },
  {
    id: 7,
    link: "",
    isActive: "",
    imgSrc: "images/banner3.jpg",
  },
  {
    id: 8,
    link: "",
    isActive: "",
    imgSrc: "images/gallery6.jpg",
  },
];
